import { useGetFetch } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

import { ConsentTemplate } from './Consents.types';

export const useGetConsentTemplates = () => {
  return useGetFetch<ConsentTemplate[]>({
    url: ApiRoutesEnum.getConsentTemplates,
  });
};
